/* eslint-disable @typescript-eslint/no-explicit-any */
// hwpx 생성 요청 저장 경로
export const hwpxRequestPath = 'hwpx_request'
// hwpx 생성 요청 data 분리 저장 경로 (heavy payload)
export const hwpxRequestDataPath = 'hwpx_request_data'
// hwpx 생성 요청 상태
export type HwpxRequest = {
  id: string // firestore document id
  data: any // hwpx로 변환할 데이터 (결함 정보 등)
  inputPath: string // script.py 및 hwpx파일을 가진 zip파일이 저장된 gcs 경로 (파일명 포함)
  outputPath: string // 완성된 hwpx파일을 저장할 gcs 경로 (파일명 포함)
  docName: string // 문서(양식)명
  progressing: number // 0: 대기, 1: 진행중, 2: 완료, 3: 실패, 4: 취소
  tryCount: number // 시도 횟수
  taskId: string
  type: string
  facilityId?: string
  createdAt: string
  completedAt?: string // hwpx 파일 생성 완료 일시
  company?: string // userid (현재 사용하지 않을듯)
  errorInfo?: any
  buildType?: 'development' | 'production' // 빌드 타입 (undefined인 경우 dev와 prod에서 둘다 보임)
}

// 실시화 동기화 관련 경로
export const syncQueuePath = 'sync_queue'

export type SyncQueue = {
  id: string
  action: 'INSERT' | 'UPDATE' | 'DELETE'
  data: any
  table: string
  timestamp: number
}

export type SyncDataTypes = 'TASKS' | 'FACILITIES' | 'FLOORPLANS'
export type SyncAction = 'INSERT' | 'UPDATE' | 'DELETE'
